import { Sparkles, Wrench } from 'lucide-react';
import { Alert, Spinner } from '@/components/ui';
import { cn } from '@/lib/cn';

interface GeneratePanelProps {
  onGenerate: () => void;
  isGenerating: boolean;
  disabled?: boolean;
  status: string | null;
  error: string | null;
}

export function GeneratePanel({ onGenerate, isGenerating, disabled = false, status, error }: GeneratePanelProps) {
  return (
    <div className="pt-2">
      <button
        type="button"
        onClick={onGenerate}
        disabled={isGenerating || disabled}
        className={cn(
          'w-full py-4 px-6 rounded-2xl font-bold text-sm sm:text-base flex items-center justify-center gap-2 shadow-lg transition-all text-white',
          isGenerating
            ? 'bg-blue-400 cursor-not-allowed opacity-80'
            : 'bg-blue-600 hover:bg-blue-500 shadow-blue-600/20 active:scale-[0.99]',
        )}
        id="generate-makeover-btn"
      >
        {isGenerating ? (
          <>
            <Spinner className="w-5 h-5" />
            <span>Processing Architectural Render...</span>
          </>
        ) : (
          <>
            <Sparkles className="w-5 h-5" />
            <span>Generate Architectural Render</span>
          </>
        )}
      </button>

      {status && (
        <p
          role="status"
          className="text-xs text-blue-700 font-mono text-center mt-2 animate-pulse flex items-center justify-center gap-1.5 font-bold"
        >
          <Wrench className="w-3.5 h-3.5 text-blue-600" />
          {status}
        </p>
      )}

      {error && <Alert className="mt-3">{error}</Alert>}
    </div>
  );
}
